import './fslightbox.js';

class LambdaLightbox
{

	static MarkdownSources = [];
	static MarkdownCaptions = [];

	static registerEvents()
	{
		Livewire.on('open-lightbox', (event) => {

			if(!event.sources && event.data) {
				event = event.data;
			}

			var captions = [];

			for(var i = 0; i < event.sources.length; i++) {
				captions.push(event.message);
			}

			var lightbox = new FsLightbox();
			lightbox.props.sources = event.sources;

			if(event.message != null) {
				lightbox.props.captions = captions;
			}

			lightbox.open();

		});

	}

	static registerMarkdownListener()
	{

		console.log("Reset Markdown Lightbox");

		this.MarkdownCaptions = [];
		this.MarkdownSources = [];

		let i = 0;

		document.querySelectorAll('.markdown-clickable-image').forEach(img =>  {

			const src = img.getAttribute('src');
			const alt = img.getAttribute('alt');

			if(alt) {
				this.MarkdownCaptions.push(alt);
			} else {
				this.MarkdownCaptions.push('');
			}

			this.MarkdownSources.push(src);

			console.log(`${src} => ${i}`);

			let num = i;

			img.addEventListener('click', () => {

				LambdaLightbox.showMarkdownLightbox(num);

			});

			i++;

		});

	}

	static showMarkdownLightbox(slot)
	{

		var lb = new FsLightbox();
		lb.props.sources = this.MarkdownSources;
		lb.props.captions = this.MarkdownCaptions;

		// Only <img> tags get this lightbox. Naming the type stops fslightbox fetching each source to
		// read its content-type, which the browser blocks for images on another origin ("Invalid source").
		lb.props.type = 'image';

		lb.open(slot);

	}


}

export default LambdaLightbox;
